export default __webpack_public_path__ + "static/media/Onsen-ui-js.6fa46789.jpg";